<div class="model-selector"
     [class.disabled]="disabled"
     [class.open]="isOpen">
  <button
    class="model-selector-trigger"
    [class.disabled]="disabled"
    (click)="toggleDropdown()"
    [attr.aria-expanded]="isOpen"
    aria-haspopup="listbox"
    data-testid="polaris-model-selector-trigger">
    <span class="model-selector-label">{{ selectedLabel }}</span>
    @if (!disabled) {
      <span class="model-selector-chevron" [class.rotated]="isOpen">&#9662;</span>
    }
  </button>
  @if (isOpen) {
    <ul class="model-selector-dropdown" role="listbox" data-testid="polaris-model-selector-dropdown">
      @for (model of availableModels; track model.value) {
        <li
          class="model-selector-option"
          [class.selected]="model.value === selectedModel"
          role="option"
          [attr.aria-selected]="model.value === selectedModel"
          (click)="selectModel(model)"
          [attr.data-testid]="'polaris-model-option-' + model.value">
          <span class="model-option-label">{{ model.label }}</span>
          @if (model.value === selectedModel) {
            <span class="model-option-check">&#10003;</span>
          }
        </li>
      }
    </ul>
  }
</div>
